module.exports = __webpack_public_path__ + "static/phoneLeaf-f4b0209bee2633fced594167bea52fb0.png";